const downloadData = [
    {
        name: "initialFiles",
        source: "./files/puzzleFiles/partOneInvestigationFiles.pdf"
    },
    {},
    {
        name: "partTwoFiles",
        source: "./files/puzzleFiles/partTwoEvidence.pdf"
    },
    {
        name: "partThreeFiles",
        source: "./files/puzzleFiles/partThreeEvidence.pdf"
    },
    {
        name: "partFourFiles",
        source: "./files/puzzleFiles/partFourEvidence.pdf"
    },
    {
        name: "partFiveFiles",
        source: "./files/puzzleFiles/partFiveEvidence.pdf"
    }
]

export default downloadData